import React, { Component } from 'react';
import MealsListWrapper from './mealsList/MealsListWrapper';
import RouteTabs from '../../routeTabs/RouteTabs';
import ClassNames from 'classnames';
import Dictionary from '../../../model/Dictionary';
import MealsDesktopProps from './MealsDesktopProps';
import './MealsDesktop.css';
import MealsSelectionContainer from '../common/mealsSelection/MealsSelectionContainer';
import Constants from '../../../model/AppConfiguration';

export default class MealsDesktopScreen extends Component {
  static propTypes = MealsDesktopProps;

  submitData = step => {
    this.props.submitFlights(Constants.REQUEST.MEALS, this.props.general, this.props.flights, step);
  };

  render () {
    const {
      routeId,
      routes,
      flights,
      selectedRoute,
      selectedTrip,
      toggleRoutes,
      editOpened,
      selectedPassenger,
      openMealsSelection,
      closeMealsSelection,
    } = this.props;

    let mainContainerClass = ClassNames({
      'col-12': !editOpened,
      'col-8': editOpened,
      'full-height': true,
    });
    let selectMealsClass = ClassNames({ 'col-4': editOpened, 'select-meals': editOpened });
    return (
      <div className='row meals'>
        <div className={mainContainerClass}>
          <h1>{Dictionary.meals.title}</h1>
          <RouteTabs
            showDate
            isMain
            routes={routes}
            selectedTrip={selectedTrip}
            selectedRoute={selectedRoute}
            toggleRoutes={toggleRoutes}
            TabContent={
              <MealsListWrapper
                flights={flights}
                routeId={routeId}
                onItemClickAction={openMealsSelection}
                selectedPassenger={selectedPassenger}
              />
            }
          />
        </div>
        <div
          id='select-meals'
          style={{ padding: 0, margin: 0, display: editOpened ? 'block' : 'none' }}
          className={selectMealsClass}
        >
          <MealsSelectionContainer
            selectedRoute={selectedRoute}
            selectedPassenger={selectedPassenger}
            handleClose={closeMealsSelection}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/meals/desktop/MealsDesktopScreen.js